import { render, staticRenderFns } from "./Producer.vue?vue&type=template&id=fa6c5c56&scoped=true&lang=pug&"
import script from "./Producer.vue?vue&type=script&lang=js&"
export * from "./Producer.vue?vue&type=script&lang=js&"
import style0 from "./Producer.vue?vue&type=style&index=0&id=fa6c5c56&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6c5c56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VApp,VBtn,VCard,VCardActions,VCardText,VCardTitle,VContainer,VContent,VDataTable,VDialog,VFlex,VLayout,VSpacer,VTextField})
